import type { AxiosResponse } from 'axios';
import { BookingAllowedStatus } from '@/widgets/Wizard/models/time-table/status';
import type { WizardOptions } from '@/widgets/Wizard/models/time-table/wizard-options';

export function parseTimeTableStatusResponse(response: AxiosResponse): BookingAllowedStatus {
    if (response.status !== 200 || !Number.isInteger(response.data.status)) {
        return BookingAllowedStatus.UNSET;
    }

    switch (parseInt(response.data.status)) {
        case 0:
            return BookingAllowedStatus.UNSET;

        case 1:
            return BookingAllowedStatus.ACTIVE_ALL;

        case 2:
            return BookingAllowedStatus.ACTIVE_SCREEN;

        case 3:
            return BookingAllowedStatus.ACTIVE_SIGNUP;

        case 4:
            return BookingAllowedStatus.INACTIVE;

        default:
            return BookingAllowedStatus.UNSET;
    }
}

export function parseTimeTableWizardOptionsResponse(response: AxiosResponse): WizardOptions | null {
    if (response.status !== 200) {
        return null;
    }

    const options: WizardOptions = {
        usePin: response.data.usePin ?? false,
    };

    if (!!response.data.salesChannel && Number.isInteger(response.data.salesChannel)) {
        options.salesChannel = parseInt(response.data.salesChannel);
    }

    return options;
}
